// Module
var code = "<page-header title=\"'网络列表'\" breadcrumbs=\"['网络']\" reload=\"true\"> </page-header>\n\n<networks-datatable ng-if=\"networks\" dataset=\"networks\" on-refresh=\"(getNetworks)\" on-remove=\"(removeAction)\"></networks-datatable>\n";
// Exports
var _module_exports = code;;
var path = 'app/docker/views/networks/networks.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;